import { NONE_ORDER } from './ShareOfTotalSpendContainer';

export const handleExport = (chartInstance, filename) => {
	if (chartInstance) {
		chartInstance.exportChart({ filename }, { chart: { width: 1200 } });
	}
};

export const getCompanyTitle = ({ title, sortOrderCompany }) => {
	if (sortOrderCompany !== NONE_ORDER) {
		return title === sortOrderCompany
			? `Top vendors ${title}`
			: `${title} vendors`;
	}
	return `Top vendors ${title}`;
};

export const getVendorsTitle = ({ title, vendorsCount, sortOrderCompany }) => {
	if (sortOrderCompany !== NONE_ORDER) {
		return `Vendors (${vendorsCount || 0}${
			title === sortOrderCompany ? '' : ' common'
		})`;
	}
	return `Vendors (${vendorsCount || 0})`;
};
